import Track from 'utils/analytics/Track';

function gaTrack(response, timing) {
  const match = response.url.match(/\b(\w+)\.\w+\//);
  Track.send({
    hitType: 'timing',
    timingCategory: 'Direction',
    timingVar: response.ok ? 'load' : 'error',
    timingValue: timing,
    timingLabel: match && match[1],
  });
}

export default gaTrack;
